module.exports = "/images/logo-white.png?a92504ee0faa659116b82997ebbcd41c";